/**
 * Sets up key dependencies needed by the viewer
 *
 * @export
 */
export function bootstrap() { }